import React from "react";
import { formatDate } from "@fullcalendar/core";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
// import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
// import axios from "../../utils/BasicAuthAPI";
import EventDetail_Calibration from "./EventDetail_Calibration";
import moment from "moment";
import { message, Radio, Tooltip } from "antd";
import "./calendar.css";
import liracrypt from "../Liracrypt/liracrypt";
import queryString from "query-string";
import { withRouter } from "react-router-dom";
import CreateTaskModal from "../../pages/PMS/CreateTaskModal";
// import { INITIAL_EVENTS, createEventId } from './event-utils'

let eventGuid = 0;

export function createEventId() {
  return String(eventGuid++);
}

class TaskCalendar extends React.Component {
  msgKey = "fetchData";

  state = {
    // weekendsVisible: true,
    currentEvents: [],
    selectedEvent: null,
    selectedEventData: null,
    visible: false,
    editMode: false,
    items: [],
    filterEvent: "both",
    // msgRef: null
  };

  calendarRef = React.createRef();
  onChange = (e, m) => {
    this.setState({ filterEvent: e.target.value }, () => {
      let calendarApi = this.calendarRef.current.calendar;
      calendarApi.refetchEvents();
    });

  };

  getEventBorderColor = (status) => {
    let color = "#e74c3c";
    switch (status) {
      case "O":
        color = "#e74c3c";
        break;
      case "C":
        color = "#2ecc71";
        break;
      case "H":
        color = "#3498db";
        break;
      case "X":
        color = "#ecf0f1";
        break;
      default:
        color = "#e74c3c";
        break;
    }
    return color;
  };

  fetchEvents = (info, successCallback, failureCallback) => {
    // console.log(info, moment(info.start));
    let that = this;
    let searchParams = queryString.parse(this.props.location?.search);
    message.loading({
      header: "Calibration Calendar",
      content: "Loading...",
      duration: 0,
      key: this.msgKey,
      style: { padding: "10px 15px" },
    });
    liracrypt
      .get("/calendar/month", {
        typ: "Calib",
        page: "calendar",
        from: moment(info.start).format("YYYY/MM/DD"),
        to: moment(info.end).format("YYYY/MM/DD"),
        plAct: "both",
        ...searchParams
      })
      .then((res, req) => {
        this.props.setPageHeader(res.data?.config?.pageTitle || "Calibration Calendar");
        let data = res.data ? res.data.data : [];
        let dataEvent = [];

        data.forEach((obj) => {
          // if (obj.hasOwnProperty("itemId") && obj.hasOwnProperty("seriesFrom") && obj.hasOwnProperty("seriesTo")) {
          let classNames = "display";
          if (this.state.filterEvent === "plan" && obj["plact"] !== "plan") {
            // nothing todo;
            classNames = "hidden";
          } else if (
            this.state.filterEvent === "actual" &&
            obj["plact"] !== "actual"
          ) {
            // nothing todo;
            classNames = "hidden";
          }

          dataEvent.push({
            id: obj.itemid,
            title: obj.itemName,
            start: moment(obj.seriesFrom).toDate(),
            end: moment(obj.seriesTo).add(86400, "seconds").toDate(),
            borderColor: that.getEventBorderColor(obj.st),
            allDay: true,
            backgroundColor: obj.seriesColor,
            textColor: "#fff",
            classNames: [classNames],
            ...obj,
          });

          // }
        });
        successCallback([...dataEvent]);
        message.success({ content: "Loaded!", duration: 1, key: that.msgKey });
      })
      .catch(function (error) {
        console.log("Error****: fetch calendar", error, that);
        message.error({
          content: "Unable to Load!",
          duration: 2,
          key: that.msgKey,
        });
      });
  };

  componentDidMount = () => {
  //  this.props.setPageHeader("Calibration Calendar");
  };
  componentWillUnmount = () => {
    delete this.currentEvents;
  };

  componentWillReceiveProps(nextProps){
    let calendarApi = this.calendarRef.current.calendar;
    setTimeout(() => {
      calendarApi.refetchEvents();
    }, 500);
      

  }

  modelCloseHandler = (reqDat) => {
    if (reqDat) {
      let calendarApi = this.state.selectedEvent.view.calendar;
      if (this.state.editMode) {

      } else {
        calendarApi.unselect(); // clear date selection
        calendarApi.addEvent({
          allDay: true,
          backgroundColor: "#4773ab",
          textColor: "#fff",
          id: createEventId(),
          title: reqDat.Name,
          start: moment(reqDat.PlanDt, "YYYY/MM/DD").toDate(),
          ...reqDat,
        });
      }
      calendarApi.refetchEvents();
    }
    this.setState({
      visible: false,
      selectedEvent: null,
      selectedEventData: null,
      editMode: false,
    });
  };

  render() {
    return (
      <>
        <div className="calendarsection">
          {/* {this.renderSidebar()} */}
          <div className="demo-app-main">
            <div className="event-filter-opt">
              <Radio.Group
                onChange={this.onChange}
                value={this.state.filterEvent}
              >
                <Radio value={"plan"}>Plan</Radio>
                <Radio value={"actual"}>Actual</Radio>
                <Radio value={"both"}>Both</Radio>
              </Radio.Group>
            </div>
            <FullCalendar
              ref={this.calendarRef}
              plugins={[dayGridPlugin, interactionPlugin]}
              headerToolbar={{
                left: "prev,dayGridMonth,next",
                center: "title",
                right: "today",
              }}
              height="600px"
              initialView="dayGridMonth"
              editable={true}
              selectable={true}
              selectMirror={true}
              dayMaxEvents={true}
              weekends={this.state.weekendsVisible}
              events={this.fetchEvents}
              // initialEvents={INITIAL_EVENTS} // alternatively, use the `events` setting to fetch from a feed
              select={this.handleDateSelect}
              eventContent={this.renderEventContent} // custom render function
              eventClick={this.handleEventClick}
              eventsSet={this.handleEvents} // called after events are initialized/added/changed/removed
              eventDrop={this.handleDropEvents}
              eventResize={this.handleEventResize}
            /* you can update a remote database when these fire:
                          eventAdd={function(){}}
                          eventChange={function(){}}
                          eventRemove={function(){}}
                          */
            />
            <CreateTaskModal
              visible={this.state.visible}
              modelCloseHandler={this.modelCloseHandler}
              data={this.state.selectedEventData}
              urlData={{ ...queryString.parse(this.props.location?.search) }}
              isEdit={this.state.editMode}
              callback={() => {
                this.calendarRef.current.calendar.refetchEvents();
              }}
            />
          </div>
        </div>
      </>
    );
  }

  renderSidebar() {
    return (
      <div className="demo-app-sidebar">
        <div className="demo-app-sidebar-section">
          <h2>Instructions</h2>
          <ul>
            <li>Select dates and you will be prompted to create a new event</li>
            <li>Drag, drop, and resize events</li>
            <li>Click an event to delete it</li>
          </ul>
        </div>
        <div className="demo-app-sidebar-section">
          <label>
            <input
              type="checkbox"
              checked={this.state.weekendsVisible}
              onChange={this.handleWeekendsToggle}
            ></input>
            toggle weekends
          </label>
        </div>
        <div className="demo-app-sidebar-section">
          <h2>All Events ({this.state.currentEvents.length})</h2>
          <ul>{this.state.currentEvents.map(this.renderSidebarEvent)}</ul>
        </div>
      </div>
    );
  }

  handleWeekendsToggle = () => {
    this.setState({
      weekendsVisible: !this.state.weekendsVisible,
    });
  };

  handleDateSelect = (selectInfo, element) => {
    const reqDat = {
      // "Func": "addevent",
      itemName: null,
      typ: "Calib",
      respid: null,
      respName: null,
      dtSel: selectInfo.startStr,
      groupid: null,
      groupLabel: null,
      seriesFrom: selectInfo.startStr ? moment(selectInfo.startStr) : null,
      seriesTo: selectInfo.startStr ? moment(selectInfo.startStr) : null,
      PlanSeriesFrom: selectInfo.startStr ? moment(selectInfo.startStr) : null,
      PlanSeriesTo: selectInfo.startStr ? moment(selectInfo.startStr) : null,
      ActualSeriesFrom: null,
      ActualSeriesTo: null,
      note: null,
      aux1: null,
      aux2: null,
      aux3: null,
      period: "2019-20",
      // source: "UI",
      st: "O",
      subTyp: null,
      ...queryString.parse(this.props.location?.search)
    };

    this.setState({
      visible: true,
      selectedEvent: selectInfo,
      editMode: false,
      selectedEventData: reqDat,
    });
  };

  handleEventClick = (clickInfo) => {

    let planEvents = this.state.currentEvents.filter((event) => {
      return (
        event.extendedProps.itemid === clickInfo.event.extendedProps.itemid &&
        event.extendedProps.plact === "plan"
      );
    });

    let actualEvents = this.state.currentEvents.filter((event) => {
      return (
        event.extendedProps.itemid === clickInfo.event.extendedProps.itemid &&
        event.extendedProps.plact === "actual"
      );
    });


    if (planEvents.length === 1 && actualEvents.length === 1) {
      planEvents = planEvents[0];
      actualEvents = actualEvents[0];
    } else if (planEvents.length === 1 && actualEvents.length === 0) {
      planEvents = planEvents[0];
      actualEvents = null;
    } else {
      planEvents = null;
      actualEvents = null;
      message.error("Invalid Event!!", 4);
      return;
    }

    let reqDat = {
      // "Func": "addevent",
      itemName: null,
      typ: "Calib",
      respid: "uid_001",
      respName: "Santosh SG",
      groupid: null,
      groupLabel: null,
      seriesFrom: null,
      seriesTo: null,
      note: null,
      aux1: null,
      aux2: null,
      aux3: null,
      period: "2019-20",
      // source: "UI",
      st: "O",
      subTyp: null,
      ...queryString.parse(this.props.location?.search)
    };
    if (clickInfo.event.extendedProps && clickInfo.event.extendedProps.itemid) {
      reqDat = {
        itemid: clickInfo.event.extendedProps.itemid,
        itemName: clickInfo.event.extendedProps.itemName,
        typ: "Calib",
        respid: clickInfo.event.extendedProps.respid,
        respName: clickInfo.event.extendedProps.respName,
        groupid: clickInfo.event.extendedProps.groupid,
        groupLabel: clickInfo.event.extendedProps.groupLabel,
        seriesFrom: clickInfo.event.extendedProps.seriesFrom
          ? moment(clickInfo.event.extendedProps.seriesFrom, "YYYY/MM/DD")
          : null,
        seriesTo: clickInfo.event.extendedProps.seriesTo
          ? moment(clickInfo.event.extendedProps.seriesTo, "YYYY/MM/DD")
          : null,
        PlanSeriesFrom:
          planEvents && planEvents.extendedProps.seriesFrom
            ? moment(planEvents.extendedProps.seriesFrom, "YYYY/MM/DD")
            : null,
        PlanSeriesTo:
          planEvents && planEvents.extendedProps.seriesTo
            ? moment(planEvents.extendedProps.seriesTo, "YYYY/MM/DD")
            : null,
        ActualSeriesFrom:
          actualEvents && actualEvents.extendedProps.seriesFrom
            ? moment(actualEvents.extendedProps.seriesFrom, "YYYY/MM/DD")
            : null,
        ActualSeriesTo:
          actualEvents && actualEvents.extendedProps.seriesTo
            ? moment(actualEvents.extendedProps.seriesTo, "YYYY/MM/DD")
            : null,
        seriesTooltipLabel: clickInfo.event.extendedProps.seriesTooltipLabel,
        seriesColor: clickInfo.event.extendedProps.seriesColor,
        note: clickInfo.event.extendedProps.note,
        aux1: clickInfo.event.extendedProps.aux1,
        aux2: clickInfo.event.extendedProps.aux2,
        aux3: clickInfo.event.extendedProps.aux3,
        period: clickInfo.event.extendedProps.period,
        st: clickInfo.event.extendedProps.st,
        subTyp: clickInfo.event.extendedProps.SubTyp
          ? clickInfo.event.extendedProps.SubTyp
          : null,
        ...queryString.parse(this.props.location?.search)
      };
    }

    this.setState({
      visible: true,
      selectedEvent: clickInfo,
      selectedEventData: reqDat,
      editMode: true,
    });
    // if (confirm(`Are you sure you want to delete the event '${clickInfo.event.title}'`)) {
    //     clickInfo.event.remove()
    // }
  };

  handleEvents = (events, a, b, c) => {

    this.setState({
      currentEvents: events,
    });
  };
  handleDropEvents = (eventDropInfo) => {

    const startDate = eventDropInfo.event.extendedProps.seriesFrom
      ? moment(eventDropInfo.event.extendedProps.seriesFrom, "YYYY/MM/DD")
      : null;
    const endDate = eventDropInfo.event.extendedProps.seriesTo
      ? moment(eventDropInfo.event.extendedProps.seriesTo, "YYYY/MM/DD")
      : null;

    let newStartDate = eventDropInfo.event.startStr
      ? moment(eventDropInfo.event.startStr, "YYYY-MM-DD")
      : null;
    let newEndDate = eventDropInfo.event.startStr
      ? moment(eventDropInfo.event.startStr, "YYYY-MM-DD")
      : null;
    if (startDate && endDate && newStartDate && newEndDate) {
      const copyNewstartDate = newStartDate.clone();
      const copyNewEndDate = newEndDate.clone();
      newEndDate = copyNewEndDate.add(endDate.diff(startDate, "days"), "days");
    }

    const reqDat = {
      plact: eventDropInfo.event.extendedProps.plact,
      itemid: eventDropInfo.event.extendedProps.itemid,
      itemName: eventDropInfo.event.extendedProps.itemName,
      typ: "Calib",
      respid: eventDropInfo.event.extendedProps.respid,
      respName: eventDropInfo.event.extendedProps.respName,
      groupid: eventDropInfo.event.extendedProps.groupid,
      groupLabel: eventDropInfo.event.extendedProps.groupLabel,
      seriesFrom: newStartDate ? newStartDate.format("YYYY/MM/DD") : null,
      seriesTo: newEndDate ? newEndDate.format("YYYY/MM/DD") : null,
      seriesTooltipLabel: eventDropInfo.event.extendedProps.seriesTooltipLabel,
      seriesColor: eventDropInfo.event.extendedProps.seriesColor,
      note: eventDropInfo.event.extendedProps.note,
      aux1: eventDropInfo.event.extendedProps.aux1,
      aux2: eventDropInfo.event.extendedProps.aux2,
      aux3: eventDropInfo.event.extendedProps.aux3,
      period: eventDropInfo.event.extendedProps.period,
      st: eventDropInfo.event.extendedProps.st,
      subTyp: eventDropInfo.event.extendedProps.SubTyp
        ? eventDropInfo.event.extendedProps.SubTyp
        : null,
      ...queryString.parse(this.props.location?.search)
    };

    liracrypt
      .patch("/calendar/event", [reqDat])
      .then((res, req) => {
        message.success("Event updated successfully!!");
        eventDropInfo.event.setExtendedProp("seriesFrom", reqDat["seriesFrom"]);
        eventDropInfo.event.setExtendedProp("seriesTo", reqDat["seriesTo"]);

      })
      .catch(function (error) {
        console.log("Error****: fetch calendar", error);
      });
  };
  handleEventResize = (eventInfo) => {

    let newStartDate = eventInfo.event.startStr
      ? moment(eventInfo.event.startStr, "YYYY-MM-DD")
      : null;
    let newEndDate = eventInfo.event.endStr
      ? moment(eventInfo.event.endStr, "YYYY-MM-DD").subtract(1, "days")
      : null;
    const reqDat = {
      plact: eventInfo.event.extendedProps.plact,
      itemid: eventInfo.event.extendedProps.itemid,
      itemName: eventInfo.event.extendedProps.itemName,
      typ: "Calib",
      respid: eventInfo.event.extendedProps.respid,
      respName: eventInfo.event.extendedProps.respName,
      groupid: eventInfo.event.extendedProps.groupid,
      groupLabel: eventInfo.event.extendedProps.groupLabel,
      seriesFrom: newStartDate ? newStartDate.format("YYYY/MM/DD") : null,
      seriesTo: newEndDate ? newEndDate.format("YYYY/MM/DD") : null,
      seriesTooltipLabel: eventInfo.event.extendedProps.seriesTooltipLabel,
      seriesColor: eventInfo.event.extendedProps.seriesColor,
      note: eventInfo.event.extendedProps.note,
      aux1: eventInfo.event.extendedProps.aux1,
      aux2: eventInfo.event.extendedProps.aux2,
      aux3: eventInfo.event.extendedProps.aux3,
      period: eventInfo.event.extendedProps.period,
      st: eventInfo.event.extendedProps.st,
      subTyp: eventInfo.event.extendedProps.SubTyp
        ? eventInfo.event.extendedProps.SubTyp
        : null,
      ...queryString.parse(this.props.location?.search)
    };
    liracrypt
      .patch("/calendar/event", [reqDat])
      .then((res, req) => {
        message.success("Event updated successfully!!");
        eventInfo.event.setExtendedProp("seriesFrom", reqDat["seriesFrom"]);
        eventInfo.event.setExtendedProp("seriesTo", reqDat["seriesTo"]);

      })
      .catch(function (error) {
        console.log("Error****: fetch calendar", error);
      });
  };

  renderEventContent = (eventInfo) => {
    let color = "#e74c3c";
    switch (eventInfo.event.extendedProps.st) {
      case "O":
        color = "#e74c3c";
        break;
      case "C":
        color = "#2ecc71";
        break;
      case "H":
        color = "#3498db";
        break;
      case "X":
        color = "#ecf0f1";
        break;
      default:
        color = "#e74c3c";
        break;
    }
    return (
      <>
        {/* <b>{eventInfo.timeText}</b> */}
        <Tooltip
          title={
            eventInfo.event.extendedProps.groupLabel +
            "_" +
            eventInfo.event.title
          }
        >
          <div
            style={{
              padding: "3px 5px",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            <b>
              {eventInfo.event.extendedProps.groupLabel +
                "_" +
                eventInfo.event.title}
            </b>
          </div>
        </Tooltip>
      </>
    );
  };

  renderSidebarEvent = (event) => {
    return (
      <li key={event.id}>
        <b>
          {formatDate(event.start, {
            year: "numeric",
            month: "short",
            day: "numeric",
          })}
        </b>
        <i>{event.title}</i>
      </li>
    );
  };
}

export default withRouter(TaskCalendar);
